import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/sideNavbar/Telegram_cai.png'
import _imports_1 from '@/assets/sideNavbar/Whatsapp_cai.png'
import _imports_2 from '@/assets/sideNavbar/facebook_cai.png'
import _imports_3 from '@/assets/bauDo/instagram_icon.png'
import _imports_4 from '@/assets/sideNavbar/18+_cai.png'


const _hoisted_1 = { class: "gift-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "middleCard" }
const _hoisted_4 = { class: "top-text" }
const _hoisted_5 = { class: "small-text" }
const _hoisted_6 = { class: "btn_container" }
const _hoisted_7 = {
  key: 1,
  class: "bottom_text"
}

import { GiftCodeData } from '@/view/giftCode/giftCodeView';
import { watch, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import MainButton from '../components/common/mainButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'giftCodeView',
  props: {
    dataSet: {},
    isTabView: { type: Boolean }
  },
  emits: ['pasteCode', 'goToShare', 'claimSubmit'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit

const props = __props

const couponCode = ref(props.dataSet.couponCode)

watch(
    () => props.dataSet.couponCode,
    val => (couponCode.value = val)
);

const pasteCode = async () => {
    try {
        const text = await navigator.clipboard.readText();
        if (!text) return;

        couponCode.value = text;
        emits('pasteCode', text);
    } catch (err) {
        console.error('Paste failed', err);
    }
};
const claimSubmit = () => {
    emits('claimSubmit', couponCode.value)
}
const goToShare = async () => {
    emits("goToShare")
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cuponContainer",
    style: _normalizeStyle({ padding: _ctx.isTabView ? '0px 0px' : '70px 0px 0px' })
  }, [
    (!_ctx.isTabView)
      ? (_openBlock(), _createBlock(CustomHeader, {
          key: 0,
          text: _ctx.$t('giftCode.exchangeReward')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: "banner",
        class: "banner-img"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_row, { class: "couponInput" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "24" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  class: "pasteInput",
                  placeholder: _ctx.$t('giftCode.enterCode'),
                  modelValue: couponCode.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event))
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('giftcode.multimedia')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('giftcode.note')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(MainButton, {
            title: _ctx.$t('common.register'),
            activeStatus: true,
            onClick: claimSubmit,
            radius: "10px !important"
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", { class: "mediaIcons" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "banner",
            class: "media-img",
            onClick: goToShare
          }),
          _createElementVNode("img", {
            src: _imports_1,
            alt: "banner",
            class: "media-img",
            onClick: goToShare
          }),
          _createElementVNode("img", {
            src: _imports_2,
            alt: "banner",
            class: "media-img",
            onClick: goToShare
          }),
          _createElementVNode("img", {
            src: _imports_3,
            alt: "banner",
            class: "media-img",
            onClick: goToShare
          }),
          _createElementVNode("img", {
            src: _imports_4,
            alt: "banner",
            class: "media-img",
            onClick: goToShare
          })
        ])
      ])
    ]),
    (_ctx.dataSet.activityInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})